<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 240px'>
        <p style='width:70px;text-align:right'>数据来源：</p>
        <el-input v-model='condition.consignorName' size='mini' style='width:150px'
                  placeholder='请输入数据来源' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p style='width:70px;text-align:right'>运单号：</p>
        <el-input v-model='condition.waybillNo' size='mini' style='width:150px'
                  placeholder='请输入运单号' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p style='width:70px;text-align:right'>车架号：</p>
        <el-input v-model='condition.frameNumber' size='mini' style='width:150px'
                  placeholder='请输入车架号'
                  @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'frameNumber')}" />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p style='width:70px;text-align:right'>提车场点：</p>
        <el-input v-model='condition.pickCar' size='mini' style='width:150px'
                  placeholder='请输入提车场点' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p style='width:70px;text-align:right'>运输方式：</p>
        <el-select v-model='condition.transportMode' filterable size='mini' style='width:150px'
                   placeholder='请选择运输方式'>
          <el-option v-for='item in transport' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navContainer' style='width: 240px'>
        <p style='width:70px;text-align:right'>导入时间：</p>
        <el-date-picker v-model='condition.cTime' style='width:150px' size='mini' type='date'
                        placeholder='选择导入时间' value-format='yyyy-MM-dd' />
      </div>
      <!--      <div class='navContainer' style='width: 240px'>
              <p style='width:70px;text-align:right'>状态：</p>
              <el-select v-model='condition.sourceType' filterable size='mini' style='width:150px'
                         placeholder='请选择状态'>
                <el-option v-for='item in sourceOption' :key='item.label' :label='item.label'
                           :value='item.value' />
              </el-select>
            </div>-->
      <div class='navContainer' style='width: 240px'>
        <p style='width:70px;text-align:right'>接口类型：</p>
        <el-select v-model='condition.isSend' filterable size='mini' style='width:150px'
                   placeholder='请选择状态'>
          <el-option v-for='item in isSendOption' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <el-button :loading='reviseLoading' size='mini' type='primary' @click='changeClick'>
          生成运输计划
        </el-button>
        <el-button size='mini' type='primary' @click='planExport'>导出</el-button>
        <el-upload
          ref='upload'
          class='upload-demo ml10'
          :disabled='uploadDis1'
          :action='uploadUrl1'
          :auto-upload='true'
          :show-file-list='false'
          :data='uploadData1'
          :http-request='uploadHttp'
          :on-success='planOnSuccess'
          :before-upload='beforeUpload'>
          <el-button size='mini' type='primary'>发送接口导入
          </el-button>
        </el-upload>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer' ref='tableCot'>
        <el-table v-loading='tableLoad' :data='TableData' row-key='id'
                  style='width: 100%;' border ref='selectTable'
                  @select='selectTable' @select-all='allSelectTable'
                  :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
                  :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}" :row-style="rowStyle">
          <el-table-column type='selection' width='50' align='center' reserve-selection />
          <el-table-column prop='consignorName' label='数据来源' align='center' show-overflow-tooltip
                           min-width='150' />
          <!-- <el-table-column prop="batchNumber" label="批次号" align="center" show-overflow-tooltip min-width="150"/> -->
          <el-table-column prop='waybillNo' label='运单号' align='center' show-overflow-tooltip
                           min-width='150' />
          <el-table-column prop='frameNumber' label='车架号' align='center' show-overflow-tooltip
                           min-width='150' />
          <el-table-column prop='isSend' label='接口类型' align='center' min-width='80'>
            <div slot-scope='scope'>{{ getState(scope.row.isSend) }}</div>
          </el-table-column>
          <el-table-column prop='pickCar' label='提车场点' align='center' show-overflow-tooltip
                           min-width='100' />
          <!-- <el-table-column prop="departurePlace" label="起运地" align="center" show-overflow-tooltip min-width="150"/>
          <el-table-column prop="arrivePlace" label="目的地" align="center" show-overflow-tooltip min-width="150"/> -->
          <el-table-column prop='departurePort' label='起运港' align='center' show-overflow-tooltip
                           min-width='100' />
          <el-table-column prop='arrivePort' label='目的港' align='center' show-overflow-tooltip
                           min-width='100' />
          <el-table-column prop='collectCar' label='收车单位' align='center' show-overflow-tooltip
                           min-width='80' />
          <el-table-column prop='brandName' label='品牌' align='center' show-overflow-tooltip
                           min-width='80' />
          <el-table-column prop='modelName' label='型号' align='center' show-overflow-tooltip
                           min-width='80' />
          <el-table-column prop='shipMode' label='模式' align='center' show-overflow-tooltip
                           min-width='80' />
          <el-table-column prop='transportMode' label='运输方式' align='center' min-width='70'>
            <template slot-scope='scope'>{{ transRulesTypeFormat(scope.row.transportMode) }}
            </template>
          </el-table-column>
          <el-table-column prop='jhTime' label='计划时间' align='center' min-width='135'>
            <template slot-scope='scope'>{{ getTime(scope.row.jhTime) }}</template>
          </el-table-column>
          <el-table-column prop='createTime' label='导入时间' align='center' min-width='135'>
            <template slot-scope='scope'>{{ getTime(scope.row.createTime) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 50, 100, 200]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :width='dialogWidth' center
               @close='dialogClose' :close-on-click-modal='false'>
      <div class='company'>
        <el-form :model='teamData' label-width='90px' :rules='rules' ref='ruleForm' v-if='!steps'>
          <div style='display:flex;align-items:flex-end'>
            <div class='line' />
            <span>基础信息</span>
          </div>
          <div style='display:flex;flex-direction: column;padding: 10px 10px 0px 0px;'>
            <el-row>
              <el-col :span='12'>
                <el-form-item label='批次号：' prop='batch'>
                  <el-input style='width:100%' v-model='teamData.batch' placeholder='请输入批次号'
                            autocomplete='off' size='small' />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='计划类型：' prop='type'>
                  <el-select filterable v-model='teamData.type' size='mini' style='width:100%'
                             placeholder='请选择计划类型' value-key='id'>
                    <el-option v-for='item in typeOpiton' :key='item.id' :label='item.attrNm'
                               :value='item.id' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='回单类型：' prop='receiptType'>
                  <el-select filterable v-model='teamData.receiptType' size='mini'
                             style='width:100%' placeholder='请选择回单类型' value-key='id'>
                    <el-option label='电子回单' :value='1' />
                    <el-option label='纸质回单' :value='2' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='委托商：' prop='name'>
                  <el-select filterable disabled v-model='teamData.name' size='mini'
                             style='width:100%' placeholder='请输入委托商' value-key='id'>
                    <el-option v-for='item in nameOption' :key='item.id' :label='item.customer_name'
                               :value='item' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='计划时间：' prop='time'>
                  <el-date-picker
                    v-model='teamData.time'
                    size='mini'
                    style='width:100%'
                    placeholder='请选择计划时间'
                    type='datetime'
                    value-format='yyyy-MM-dd HH:mm' />
                </el-form-item>
              </el-col>
              <!-- <el-col :span="7">
                <el-form-item label="运输条款：" prop="transportType1">
                  <el-select filterable v-model="teamData.transportType1" @change="shipTypeChange($event,1)" size="mini" style="width:100%;" placeholder="请选择运输条款">
                    <el-option label="主机厂库房" :value="'VDC'"/>
                    <el-option label="港口" :value="'GK'"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label-width="0px" prop="transportType2">
                  <span style="display:inline-block;width:15px;text-align:center">-</span>
                  <el-select filterable v-model="teamData.transportType2" @change="shipTypeChange($event,2)" size="mini" style="width:calc(100% - 15px);" placeholder="请选择运输条款">
                    <el-option label="港口" :value="'GK'"/>
                    <el-option label="到中专库、区域" :value="'VSC'"/>
                    <el-option label="到经销商门店" :value="'DO'"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="运输方式：" prop="transport">
                  <el-select filterable v-model="teamData.transport" size="mini" @focus="verifyType" @change="transportChange" style="width:100%" placeholder="请选择运输方式">
                    <el-option v-for="item in transportOption" :key="item.id" :label="item.name" :value="item.id"/>
                  </el-select>
                </el-form-item>
              </el-col> -->
            </el-row>
          </div>
          <div>
            <div style='display:flex;align-items:flex-end'>
              <div class='line' />
              <span>委托车信息</span>
            </div>
          </div>
          <div class='productTable'>
            <el-table
              :data='teamData.table'
              style='width: 100%'
              border
              :header-cell-style="{'color':'#7F7F7F;','font-size':'13px;','height':'48px;'}"
              :cell-style="{'color':'#7F7F7F;','font-size':'13px;'}">
              <el-table-column label='运单号' align='center' prop='supplier' min-width='120'>
                <!-- <el-input slot-scope="scope" v-model="teamData.table[scope.$index].supplier" size="mini" :style="'width:100%'" placeholder="运单号"/> -->
              </el-table-column>
              <el-table-column label='车架号' align='center' prop='num' min-width='120'>
                <!-- <el-input slot-scope="scope" v-model="teamData.table[scope.$index].num" size="mini" :style="'width:100%'" placeholder="车架号"/> -->
              </el-table-column>
              <!-- <el-table-column label="起始区域" align="center" prop="startArea" min-width="100px">
                <template slot-scope="scope">
                  <el-cascader size="mini" style="width:100%" v-model="scope.row.startArea"
                    placeholder="请选择起始区域" :options="areaOption" :disabled="scope.row.startAreaType"
                    :props="{value: 'id', label:'cityName', children: 'children'}" clearable filterable/>
                </template>
              </el-table-column> -->
              <el-table-column label='起始港' align='center' prop='startPort' min-width='100px'>
                <template slot-scope='scope'>
                  <el-select :disabled='scope.row.startPortType'
                             @change="portChange($event, scope.$index,'start')"
                             v-model='scope.row.startPort' filterable size='mini' style='width:100%'
                             placeholder='请选择起始港' value-key='id'
                  >
                    <el-option v-for='item in portOption' :key='item.id' :label='item.supplier_name'
                               :value='item.id' />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label='到达港' align='center' prop='endPortType' min-width='100px'>
                <template slot-scope='scope'>
                  <el-select :disabled='scope.row.endPortType'
                             @change="portChange($event, scope.$index,'end')"
                             v-model='scope.row.endPort' filterable size='mini'
                             style='width:100%' placeholder='请选择交车港' value-key='id'
                  >
                    <el-option v-for='item in portOption' :key='item.id' :label='item.supplier_name'
                               :value='item.id' />
                  </el-select>
                </template>
              </el-table-column>
              <!-- <el-table-column label="交车区域" align="center" prop="endArea" min-width="100px">
                <template slot-scope="scope">
                  <el-cascader size="mini" style="width:100%" v-model="scope.row.endArea"
                    placeholder="请选择交车区域" :options="areaOption" :disabled="scope.row.endAreaType"
                    :props="{value: 'id', label:'cityName', children: 'children'}" clearable filterable/>
                </template>
              </el-table-column> -->
              <el-table-column label='提车场点' align='center' prop='extract' min-width='100'>
                <!-- <el-input slot-scope="scope" v-model="teamData.table[scope.$index].extract" size="mini" style="width:100%" placeholder="提车场点"/> -->
              </el-table-column>
              <el-table-column label='收车单位' align='center' prop='charge' min-width='100'>
                <!-- <el-input slot-scope="scope" v-model="teamData.table[scope.$index].charge" size="mini" style="width:100%" placeholder="收车单位"/> -->
              </el-table-column>
              <el-table-column label='经销商' align='center' prop='dealer' min-width='100'>
                <!-- <el-input slot-scope="scope" v-model="teamData.table[scope.$index].dealer" size="mini" style="width:100%" placeholder="经销商"/> -->
              </el-table-column>
              <el-table-column label='车型' align='center' prop='brand' min-width='120px'>
                <el-cascader
                  size='mini' filterable
                  slot-scope='scope'
                  v-model='teamData.table[scope.$index].brand'
                  :options='brandOption'
                  :props="{value:'id',label:'model',children:'carModel'}"
                  @change='brandChange($event, scope.$index)' />
              </el-table-column>
              <el-table-column label='颜色' align='center' prop='color'>
                <el-input slot-scope='scope' v-model='teamData.table[scope.$index].color'
                          size='mini' :style="'width:100%'" placeholder='颜色'
                          @blur='colorChange(teamData.table[scope.$index].color, scope.$index)' />
              </el-table-column>
              <el-table-column label='交接附件' align='center' prop='remark'>
                <el-input slot-scope='scope' v-model='teamData.table[scope.$index].remark'
                          size='mini' :style="'width:100%'" placeholder='附件'
                          @blur='remarkChange(teamData.table[scope.$index].remark, scope.$index)' />
              </el-table-column>
              <el-table-column prop='operation' label='操作' align='center' width='50px'>
                <div slot-scope='scope'
                     style='display:flex;align-items:center;justify-content:center'
                     v-if='teamData.table.length>1'>
                  <img alt='' :src="require('@/assets/images/u725.png')"
                       :style="'width:22px;height:22px;cursor: pointer;'"
                       @click='removeClick(scope.$index)' />
                </div>
                <div v-else>--</div>
              </el-table-column>
            </el-table>
          </div>
          <div class='btnContainer'>
            <el-button size='small' class='searchBtn' :loading='loading' @click='saveClick'>保存
            </el-button>
            <el-button size='small' class='resetBtn' @click='dialogClose'>关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    importPlanCvPageList,
    importPlanAdd,
    shipDeployPublicSelectPort,
    getCarSerieList,
  } from '@/service/vehiclelog';
  import { getParam, customerInfoSelectList } from '@/service/getData';
  import { formatDateTime } from '@/config/mUtils';
  import { getSessionStore } from '@/config/mUtils';
  import { getImport, getImportUrl } from '@/service/getIP';
  import { baseUrl } from '@/config/env';

  export default {
    data() {
      return {
        brandOption: [],  // 车型
        condition: {
          consignorName: '',    // 数据来源
          waybillNo: '',      // 运单编号
          frameNumber: '',      // 车架号
          transportMode: '',  // 运输方式
          pickCar: '',    // 提车场点
          cTime: '',   // 导入时间
          // sourceType: '',   // 状态
          isSend: '', // 接口类型
          size: 10,
          page: 1,
        },
        // 运输方式
        transport: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '公路',
          },
          {
            value: 2,
            label: '水路',
          },
          {
            value: 3,
            label: '水陆联运',
          },
        ],
        // 状态
        sourceOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待分配运输',
          },
          {
            value: 1,
            label: '已分配运输',
          },
          {
            value: 2,
            label: '运输中',
          },
          {
            value: 3,
            label: '已交车',
          },
        ],
        // 接口类型
        isSendOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: '0',
            label: '入港',
          },
          {
            value: '1',
            label: '装船',
          },
          {
            value: '2',
            label: '发运',
          },
          {
            value: '3',
            label: '组配',
          },
          {
            value: '4',
            label: '接口完成',
          },
        ],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableData: [],  // 表格数据
        checkTable: [],  // 表格选中数据
        dialogTitle: '',
        dialogVisible: false,
        steps: 0,
        dialogWidth: '',
        brandMap: new Map(),//保存品牌型号id，名称
        visible: false,//批量修改显示
        loading: false,
        reviseLoading: false,  // 修改按钮加载状态
        portOption: [],
        teamData: {
          plan: '',
          batch: '',
          number: '',
          type: '',
          terms: '',//运输方式
          name: '',
          time: '',
          router: {
            line_name: '',
            id: '',
          },
          brandModel: '',//品牌型号
          transportType1: '',//运输条款
          transportType2: '',//运输条款
          table: [],
        },
        rules: {
          receiptType: [
            {
              required: true,
              message: '请选择回单类型',
              trigger: 'blur',
            },
          ],
          type: [
            {
              required: true,
              message: '请选择计划类型',
              trigger: 'change',
            },
          ],
          transport: [
            {
              required: true,
              message: '请选择运输方式',
              trigger: 'change',
            },
          ],
          transportType1: [
            {
              required: true,
              message: '请选择运输条款',
              trigger: 'change',
            },
          ],
          transportType2: [
            {
              required: true,
              message: '请选择运输条款',
              trigger: 'change',
            },
          ],
          batch: [
            {
              required: true,
              message: '请输入批次号',
              trigger: 'blur',
            },
          ],
          brandModel: [
            {
              required: true,
              message: '请选择品牌型号',
              trigger: 'blur',
            },
          ],
          name: [
            {
              required: true,
              message: '请选择委托商',
              trigger: 'change',
            },
          ],
          time: [
            {
              required: true,
              message: '请选择计划时间',
              trigger: 'change',
            },
          ],
        },
        nameOption: [],  // 委托商
        typeOpiton: [],  // 计划类型
        transportOption: [],  // 运输方式
        areaOption: [],   // 区域列表
        uploadDis1: false, // 批量导入状态
        uploadUrl1: '', // 托运费用核对导入
        // 托运费用核对导入
        uploadData1: {
          mFile: '',// 托运费用核对导入
        },
      };
    },
    computed: {
      // 状态
      getState() {
        return function(state) {
          switch (state) {
            case 0:
              return '入港';
            case 1:
              return '装船';
            case 2:
              return '发运';
            case 3:
              return '组配';
            case 4:
              return '接口完成';
            default:
              return '--';
          }
        };
      },
      // 时间格式
      getTime() {
        return function(time) {
          return time ? formatDateTime(time, 'yyyy-mm-dd hh:ii:ss') : '';
        };
      },
      // 运输方式
      transRulesTypeFormat() {
        return function(value) {
          let text = '';
          value = value ? value.toString() : value;
          switch (value) {
            case '1':
              text = '公路';
              break;
            case '2':
              text = '水路';
              break;
            case '3':
              text = '水陆联运';
              break;

          }
          return text;

        };
      },
    },
    mounted() {
      // 区域
      this.areaOption = JSON.parse(getSessionStore('areaList'));

      // this._importPlanCvPageList();
      this._customerInfoSelectList();
      //查询计划类型
      this._planType();
      this._brandData();
      this._getPortList();
      this.uploadUrl1 = getImportUrl('/minshengLogistics/importAddFocus');
    },
    methods: {
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'frameNumber':
            this.condition.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
      // 分页查询
      async _importPlanCvPageList() {
        this.tableLoad = true;
        const res = await importPlanCvPageList(this.condition);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableData = res.data.records;
        this.total = res.data.total;
      },
      // 查询
      searchBtn() {
        this.page = 1;
        this._importPlanCvPageList();
      },
      // 重置
      resetBtn() {
        for (let key in this.condition) {
          if (key != 'page') {
            this.condition[key] = '';
          } else {
            this.condition.page = 1;
            this.condition.size = 10;
          }
        }
      },
      add0(m) {
        return m < 10 ? '0' + m : m;
      },
      // 时间格式转换
      transformTime(date) {
        var d = new Date(date);
        var datetime = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        return datetime;
      },
      // 时间格式转换
      transformTime1(date) {
        var d = new Date(date);
        var datetime = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        datetime += ' ' + this.add0(d.getHours()) + ':' + this.add0(d.getMinutes());
        return datetime;
      },
      //查询计划类型
      async _planType() {
        const res4 = await getParam({ categoryCd: 'contract_price' });
        if (res4.status !== 0) {
          this.$message.error(res4.message);
        } else {
          this.typeOpiton = res4.data.map(item => {
            return {
              attrNm: item.classaName,
              id: item.id,
            };
          });
        }
      },
      //查询委托车品牌信息
      async _brandData() {
        const res5 = await getCarSerieList();
        if (res5.status !== 0) {
          this.$message.error(res5.message);
        } else {
          this.brandOption = res5.data.map(item => {
            //保存第一层id 名称
            this.brandMap.set(item.id, item.brand);
            item.carModel.forEach(carItem => {
              this.brandMap.set(carItem.id, carItem.model);
            });
            return {
              ...item,
              model: item.brand,
            };
          });
        }
      },
      // 获取委托商
      async _customerInfoSelectList() {
        //查询委托商
        const res3 = await customerInfoSelectList();
        if (res3.status !== 0) {
          this.$message.error(res3.message);
        } else {
          this.nameOption = res3.data;
        }
      },
      // 获取港口
      async _getPortList() {
        let res = await shipDeployPublicSelectPort();
        this.portOption = res.data;
      },
      // 改变每页数据条数
      contractSizeChange(sizes) {
        this.condition.size = sizes;
        this._importPlanCvPageList();
      },
      // 改变当前页
      contractCurrentChange(page) {
        this.condition.page = page;
        this._importPlanCvPageList();
      },
      // 生成运输计划 —— 打开弹窗按钮
      async changeClick() {
        console.log(this.checkTable);
        if (this.checkTable.length <= 0) {
          return this.$message.warning('请选择至少一条数据');
        }
        this.reviseLoading = true;
        this.dialogTitle = '生成运输计划';
        this.dialogWidth = '1050px';
        this.teamData = {
          batch: this.checkTable[0].batchNumber,  // 批次号
          type: this.checkTable[0].planTypeId,    // 计划类型
          receiptType: this.checkTable[0].receiptType,  // 回单类型
          name: {
            id: this.checkTable[0].consignorId,
            customer_name: this.checkTable[0].consignorName,
            coordinate: this.checkTable[0].coordinate,
          }, // 委托商
          time: this.transformTime1(this.checkTable[0].jhTime),    // 计划时间
          transportType1: this.checkTable[0].transRulesType ? this.checkTable[0].transRulesType.split('-')[0] : '',   // 运输条款
          transportType2: this.checkTable[0].transRulesType ? this.checkTable[0].transRulesType.split('-')[1] : '',   // 运输条款
          transport: this.checkTable[0].transportMode,   // 运输方式
          table: [],
        };

        this.checkTable.forEach(item => {
          this.teamData.table.push({
            interId: item.id,
            startArea: item.startArea,   // 起始区域
            endArea: item.endArea,   // 交车区域
            supplier: item.waybillNo,   // 运单号
            num: item.frameNumber,    // 车架号
            startPort: item.departurePortId,  // 起始港
            endPort: item.arrivePortId,    // 到达港
            extract: item.pickCar,    //  提车场点
            charge: item.collectCar,   // 收车单位
            dealer: item.distributor,   // 经销商
            brand: [item.brandId, item.modelId],   // 车型
            color: item.color,   // 颜色
            remark: item.fileName,  // 交接附件
            // startAreaType: true,
            // endAreaType: true,
            startPortType: false,
            endPortType: false,
          });
        });
        // this.transportChange(this.checkTable[0].transportMode);
        this.reviseLoading = false;
        this.dialogVisible = true;
      },
      // 生成运输计划 —— 操作删除
      removeClick(index) {
        this.$refs.selectTable.toggleRowSelection(this.checkTable[index], false);
        this.checkTable.splice(index, 1);
        this.teamData.table.splice(index, 1);
      },
      // 生成运输计划 —— 确认
      async saveClick() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            let flg = false;
            for (let i = 0; i < this.teamData.table.length; i++) {
              for (let j in this.teamData.table[i]) {
                if (j == 'brand' && (!this.teamData.table[i][j] || this.teamData.table[i][j] == '')) flg = true;
                if (j == 'startPort' && (!this.teamData.table[i][j] || this.teamData.table[i][j] == '')) flg = true;
                if (j == 'endPort' && (!this.teamData.table[i][j] || this.teamData.table[i][j] == '')) flg = true;
              }
            }
            if (flg) {
              return this.$message.warning('每一项必须填完！');
            }
            const arr = this.teamData.table.map(item => {
              return {
                modelId: item.brand[1],
                brandId: item.brand[0],
                departurePortId: item.startPort,
                arrivePortId: item.endPort,
                color: item.color,
                fileName: item.remark,
                interId: item.interId,
              };
            });
            let str = '';
            this.typeOpiton.forEach(item => {
              if (item.id === this.teamData.type) str = item.attrNm;
            });
            const obj = {
              batchNumber: this.teamData.batch,   //批次号
              planTypeId: this.teamData.type,    //计划类型id
              planTypeName: str,    //计划类型名称
              consignorId: this.teamData.name.id,    //委托商id
              consignorName: this.teamData.name.customer_name,    //委托商名称
              planTime: this.teamData.time,     //计划时间
              receiptType: this.teamData.receiptType,
              transportChildCvList: arr,
            };
            console.log(obj);
            // return false
            this.loading = true;
            const res = await importPlanAdd(obj);
            this.loading = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._importPlanCvPageList();
            this.dialogVisible = false;
            this.$refs.ruleForm.resetFields();
            this.steps = 0;
          } else {
            return false;
          }
        });

      },
      // 生成运输计划 —— 弹窗关闭
      dialogClose() {
        this.steps = 0;
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
        //恢复默认值
        this.teamData = {
          plan: '',
          batch: '',
          number: '',
          type: '',
          name: '',
          time: '',
          brandModel: '',//品牌型号
          transportType1: '',//运输条款
          transportType2: '',//运输条款
          table: [],
        };
      },
      // 委托车状态
      formatter(row) {
        let text = '';
        switch (row.state) {
          case 0:
            text = '待分配运输';
            break;
          case 1:
            text = '已分配运输';
            break;
          case 2:
            text = '运输中';
            break;
          case 3:
            text = '已交车';
            break;
        }
        return text;
      },
      // 表格数据选中提示
      selectTable(val, row) {
        if (val.length > 0) {
          let temp = val[0].consignorId;
          if (row.consignorId != temp) {
            this.$refs.selectTable.toggleRowSelection(row, false);
            return this.$message.warning('数据来源必须相同');
          } else {
            this.checkTable = val;
          }
        } else {
          this.checkTable = val;
        }
      },
      rowStyle({ row }) {
        return this.checkTable.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 全选按钮
      allSelectTable(value) {
        if (value.length > 0) {
          let type = false;
          let temp = value[0].consignorId;
          value.forEach(item => {
            if (item.consignorId != temp) {
              type = true;
            }
          });
          if (type) {
            this.$refs.selectTable.clearSelection();
            return this.$message.warning('数据来源必须相同');
          } else {
            this.checkTable = value;
          }
        }
      },

      // 运输条款改变
      shipTypeChange(val, type) {
        this.transportOption = [];
        if (type == 1) {
          this.teamData.transportType2 = '';
        }
        if (this.teamData.table.length > 0) {
          this.teamData.table.forEach(item => {
            item.startAreaType = true;
            item.endAreaType = true;
            item.startPortType = true;
            item.endPortType = true;
            item.startArea = '';
            item.endArea = '';
            item.startPort = '';
            item.endPort = '';
          });
        }
        this.$forceUpdate();
      },
      // 验证运输条款
      verifyType() {
        this.transportOption = [];
        let type1 = this.teamData.transportType1;
        let type2 = this.teamData.transportType2;
        if (!type1 || type1 == '' || !type2 || type2 == '') {
          return this.$message.warning('请先选择运输条款！');
        }
        if (type1 == 'GK' && type2 == 'GK') {
          this.transportOption = [{
            id: 1,
            name: '公路',
          }, {
            id: 2,
            name: '水路',
          }];
        } else {
          this.transportOption = [{
            id: 1,
            name: '公路',
          }, {
            id: 3,
            name: '水陆联运',
          }];
        }
      },
      // 运输方式改变
      transportChange(val) {
        let type = this.teamData.transportType1 + '-' + this.teamData.transportType2;
        if (val.id == 1) {
          if (type == 'GK-GK') {
            this.teamData.table.forEach(item => {
              item.startAreaType = true;
              item.endAreaType = true;
              item.startPortType = false;
              item.endPortType = false;
            });
          }
          if (type == 'GK-VSC' || type == 'GK-DO') {
            this.teamData.table.forEach(item => {
              item.startAreaType = true;
              item.endAreaType = false;
              item.startPortType = false;
              item.endPortType = true;
            });
          }
          if (type == 'VDC-GK') {
            this.teamData.table.forEach(item => {
              item.startAreaType = false;
              item.endAreaType = true;
              item.startPortType = true;
              item.endPortType = false;
            });
          }
          if (type == 'VDC-VSC' || type == 'VDC-DO') {
            this.teamData.table.forEach(item => {
              item.startAreaType = false;
              item.endAreaType = false;
              item.startPortType = true;
              item.endPortType = true;
            });
          }
        } else if (val.id == 2) {
          if (type == 'GK-GK') {
            this.teamData.table.forEach(item => {
              item.startAreaType = true;
              item.endAreaType = true;
              item.startPortType = false;
              item.endPortType = false;
            });
          }
        } else {
          if (type == 'GK-VSC' || type == 'GK-DO') {
            this.teamData.table.forEach(item => {
              item.startAreaType = true;
              item.endAreaType = false;
              item.startPortType = false;
              item.endPortType = false;
            });
          }
          if (type == 'VDC-GK' || type == 'VDC-VSC' || type == 'VDC-DO') {
            this.teamData.table.forEach(item => {
              item.startAreaType = false;
              item.endAreaType = false;
              item.startPortType = false;
              item.endPortType = false;
            });
          }
        }
        this.$forceUpdate();
      },
      // 港口选择
      portChange(val, index, type) {
        if (this.teamData.table[index].startPort === this.teamData.table[index].endPort) {
          if (type === 'start') {
            this.teamData.table[index].startPort = '';
          } else {
            this.teamData.table[index].endPort = '';
          }
          return this.$message.warning('起始港口与交车港口不能相同！');
        }
        if (index === 0) {
          if (type === 'start') {
            this.teamData.table.forEach(res => {
              res.startPort = val;
            });
          } else {
            this.teamData.table.forEach(res => {
              res.endPort = val;
            });
          }
        }
      },
      // 生成运输计划 车型选择
      brandChange(val, index) {
        if (index === 0) {
          this.teamData.table.forEach(res => {
            res.brand = val;
          });
        }
      },
      // 生成运输计划 颜色输入
      colorChange(val, index) {
        console.log(val);
        if (index === 0) {
          this.teamData.table.forEach(res => {
            res.color = val;
          });
        }
      },
      // 生成运输计划 交接附件输入
      remarkChange(val, index) {
        console.log(val);
        if (index === 0) {
          this.teamData.table.forEach(res => {
            res.remark = val;
          });
        }
      },
      beforeUpload(file) {
        this.tableLoad1 = true;
        this.uploadDis1 = true;
        if (file.name.split('.')[file.name.split('.').length - 1] == 'xls' || file.name.split('.')[file.name.split('.').length - 1] == 'xlsx') {
          this.uploadData1.mFile = file.name;
        } else {
          this.uploadDis1 = false;
          this.tableLoad1 = false;
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      uploadHttp(content) {
        let formData = new FormData();
        formData.append('file', content.file, content.file.name);
        console.log(content);
        console.log(formData);
        let that = this;
        this.$axios({
          method: 'post',
          url: content.action,
          timeout: 600 * 1000,
          data: formData,
          headers: { 'content-type': 'multipart/form-data' },
        })
          .then(res => {
            this.uploadDis1 = false;
            this.tableLoad1 = false;
            console.log(res.data);
            if (res.data.status !== 0) return that.$message.error(res.data.message);
            that.$message.success(res.data.message);
            // this.tableData1 = res.data.data;
            // that._transportPlanCvPageList()
          })
          .catch(error => {
            if (error.response) {
              that.$message.error('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
              console.log('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
            } else if (error.request) {
              that.$message.error('配时文件上传失败，服务器端无响应');
              console.log('配时文件上传失败，服务器端无响应');
            } else {
              that.$message.error('配时文件上传失败，请求封装失败');
              console.log('配时文件上传失败，请求封装失败');
            }
            this.uploadDis1 = false;
            // this.tableLoad1 = false;
          });
      },
      /**
       * 核对对账单 导入 成功函数
       * @param res 上传成功回调
       */
      planOnSuccess(res) {
        this.uploadDis1 = false;
        this.tableLoad1 = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        // this._transportPlanCvPageList()
        // this.TableDatas = res.data;
        this.$forceUpdate();
      },
      planExport() {
        // let token = getSessionStore('token');
        // let url = `${baseUrl}/platform/inter/transportChild/interChildExport?access_token=${token}`;
        // url += `&consignorName=${this.condition.consignorName}`;
        // url += `&waybillNo=${this.condition.waybillNo}`;
        // url += `&frameNumber=${this.condition.frameNumber}`;
        // url += `&pickCar=${this.condition.pickCar}`;
        // url += `&transportMode=${this.condition.transportMode}`;
        // url += `&cTime=${this.condition.cTime}`;
        // // url += `&sourceType=${this.condition.sourceType}`;
        // url += `&isSend=${this.condition.isSend}`;
        // window.location.href = url;
        window.exportExcelGet('/platform/inter/transportChild/interChildExport', `consignorName=${this.condition.consignorName}&waybillNo=${this.condition.waybillNo}&frameNumber=${this.condition.frameNumber}&pickCar=${this.condition.pickCar}&transportMode=${this.condition.transportMode}&cTime=${this.condition.cTime}&isSend=${this.condition.isSend}`);
      },

    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 240px;
      margin-bottom: 10px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-height: calc(100% - 200px);

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 15px;
        width: 100%;

        ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
          color: #606266;
          content: "全选";
          font-size: 12px;
          margin-left: 2px;

        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }

    }

    .inpt {
      ::v-deep {
        .el-input__inner {
          border: 1px solid #DCDFE6 !important;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      // max-height:75vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 40%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .company {
      width: 100%;
      padding: 20px 20px 10px;

      .productTable {
        margin-top: 15px;
        margin-right: 10px;

        ::v-deep {
          .el-input--mini .el-input__inner {
            width: 100%;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }

          .el-table td, .el-table th {
            padding: 0;
          }
        }

        .tableAddBtnContainer {
          border: 1px solid #EBEEF5;;
          border-top-style: none;
          width: 100%;
          height: 35px;
          display: flex;
          align-items: center;
          padding-left: 15px;

          .AddContainer {
            display: flex;
            align-items: center;

            &:hover {
              cursor: pointer;
            }
          }

          img {
            object-fit: cover;
            margin-right: 5px;
          }

          p {
            font-size: 13px;
            color: #F59A23;
            font-family: 'Arial Normal', 'Arial', sans-serif;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-input__inner {
          // border: none;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item {
          margin-bottom: 15px;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      hr {
        margin: 0;
        position: absolute;
        width: 100%;
        bottom: 5px;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 5px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }

      .el-radio__label {
        padding-left: 5px;
      }

      .el-radio {
        margin-right: 10px;
      }
    }

    ::v-deep.update {
      font-size: 14px;
      color: rgba(51, 136, 255, 1);
      /*text-decoration: underline;*/
      & > a:visited {
        color: rgba(51, 136, 255, 1); /* 访问过的链接样式 */
      }

    }

  }

  ::v-deep {
    .company[data-v-5d3fda04] .el-form-item {
      margin-bottom: 0px !important;
    }

    .company[data-v-5d3fda04] .el-form-item__label {
      font-weight: 400 !important;
      color: #000;
    }

    td {
      height: 40px !important;
    }

    .el-table .ui-warning-row {
      background: #DDD !important;
    }

    .el-table .ui-warning-row .cell {
      color: red;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-dialog__body {
      max-height: 70vh;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .elradio {
      span:hover {
        color: #002fc1;
      }

      .el-radio {
        margin-bottom: 10px !important;
      }
    }

  }

  ::v-deep.BatchModifyC {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #fdfdfd !important;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #050505 !important;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #000000 !important;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-dialog__body {
      max-height: 600px;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
</style>
